import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchJob, changeJob } from "../features/job/jobSlice";

export default function EditJob() {
  const dispatch = useDispatch();
  const { jobId } = useParams("jobId");
  const navigate =useNavigate();

  const [title, setTitle] = useState("");
  const [type, setType] = useState("");
  const [salary, setSalary] = useState("");
  const [deadline, setDeadline] = useState("");

  useEffect(() => {
    dispatch(fetchJob(jobId));
  }, [dispatch, jobId]);
  const { editjob } = useSelector((state) => state.jobs);

  useEffect(() => {
    const { id, title, type, salary, deadline } = editjob || {};
    if (id) {
      setTitle(title);
      setType(type);
      setSalary(salary);
      setDeadline(deadline);
    }
  }, [editjob]);

  const handlesubmit = (e) => {
    e.preventDefault();    
    dispatch(
      changeJob({
        id: jobId,
        data: {
          title: title,
          type: type,
          salary: salary,
          deadline: deadline,
        },
      })      
    );
    navigate("/");
  };

  return (
    <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
      <h1 className="mb-10 text-center lws-section-title">Edit Job</h1>
      <div className="max-w-3xl mx-auto">
        <form onSubmit={handlesubmit} className="space-y-6">
          <div className="fieldContainer">
            <label
              htmlFor="lws-JobTitle"
              className="text-sm font-medium text-slate-300"
            >
              Job Title
            </label>
            <select
              id="lws-JobTitle"
              name="lwsJobTitle"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            >
              <option value="" hidden>
                Select Job
              </option>
              <option>Software Engineer</option>
              <option>Software Developer</option>
              <option>Full Stack Developer</option>
              <option>MERN Stack Developer</option>
              <option>DevOps Engineer</option>
              <option>QA Engineer</option>
              <option>Product Manager</option>
              <option>Social Media Manager</option>
              <option>Senior Executive</option>
              <option>Junior Executive</option>
              <option>Android App Developer</option>
              <option>IOS App Developer</option>
              <option>Frontend Developer</option>
              <option>Frontend Engineer</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobType">Job Type</label>
            <select
              id="lws-JobType"
              name="lwsJobType"
              value={type}
              onChange={(e) => setType(e.target.value)}
              required
            >
              <option value="" hidden>
                Select Job Type
              </option>
              <option>Full Time</option>
              <option>Internship</option>
              <option>Remote</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobSalary">Salary</label>
            <div className="flex border rounded-md shadow-sm border-slate-600">
              <span className="input-tag">BDT</span>
              <input
                type="number"
                name="lwsJobSalary"
                id="lws-JobSalary"
                required
                className="!rounded-l-none !border-0"
                placeholder="20,00,000"
                value={salary}
                onChange={(e) => setSalary(e.target.value)}
              />
            </div>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lws-JobDeadline">Deadline</label>
            <input
              type="date"
              value={deadline}
              name="lwsJobDeadline"
              id="lws-JobDeadline"
              required
              onChange={(e) => setDeadline(e.target.value)}
            />
          </div>

          <div className="text-right">
            <button
              type="submit"
              id="lws-submit"
              className="cursor-pointer btn btn-primary w-fit"
            >
              Edit
            </button>
          </div>
        </form>
      </div>
    </main>
  );
}
